import { entityMasterSingleEditFactory } from 'common/entity/generic/SingleEntityEditContainer';
import { Shift } from 'common/models/internal/Shift';
import { teamsSelector } from 'common/redux/selectors/teamSelector';
import { shift as shiftApi } from 'common/middleware/api';
import { FieldTypeEnum } from 'common/enums/FieldTypeEnum';
import CodeInputWithId from 'common/entity/generic/CodeInputWithId';
import shiftMasterIds from 'common/tests/masterManagement/shiftMaster.json';

import ShiftActions from 'common/redux/actions/shiftMaster';
import { ENTITY_NAME_ID } from 'common/constants/entity/shiftMaster';

const SHIFT_FIELDS = [
    {
        accessor: 'code',
        label: 'shiftForm.code',
        placeholder: 'shiftForm.codePlaceholder',
        helpText: 'shiftForm.codeTooltip',
        required: true,
        type: FieldTypeEnum.Text,
        disabledOnEdit: true,
        component: CodeInputWithId,
        extraProps: ({ entity, field, props }) => {
            const {
                validateDuplicateId,
                onValidateDuplicateIdChange,
                clientId
            } = props;
            return {
                validateDuplicateId,
                onValidateDuplicateIdChange,
                id: entity.getIn(['id']),
                code: entity.getIn(field.absoluteAccessor),
                clientId
            };
        },
        onChangeHandler: ({ entity, value }) => {
            const { id, code } = value;
            if ('id' in value) {
                return entity.setId(id);
            } else if ('code' in value) {
                return entity.setCode(code);
            }
        },
        testId: shiftMasterIds.addShift.inputCode
    },
    {
        accessor: 'workingDays',
        label: 'shiftForm.workingDays',
        type: FieldTypeEnum.WorkingDaysWithOffset,
        required: true,
        testId: shiftMasterIds.addShift.workingDaysSelectorInput,
        extraProps: ({ t }) => {
            return {
                translationsObject: {
                    add: t('shiftForm.addWorkingDays'),
                    change: t('shiftForm.changeWorkingDays'),
                    startLocationPlaceholder: t(
                        'shiftForm.startLocationPlaceholder'
                    ),
                    endLocationPlaceholder: t(
                        'shiftForm.endLocationPlaceholder'
                    )
                }
            };
        },
        getProcessedValueForField: ({ entity }) => entity.initializeWeekDays()
    },
    {
        accessor: 'name',
        label: 'shiftForm.name',
        placeholder: 'shiftForm.namePlaceholder',
        required: true,
        type: FieldTypeEnum.Text,
        testId: shiftMasterIds.addShift.shiftName
    },
    {
        accessor: 'teamId',
        label: 'shiftForm.team',
        helpText: 'shiftForm.teamTooltip',
        type: FieldTypeEnum.Team
    },
    {
        accessor: 'customProperties',
        type: FieldTypeEnum.CustomFields,
        extraProps: () => {
            return {
                settingsName: 'shiftSettings'
            };
        }
    }
];

const SingleShiftEditContainer = entityMasterSingleEditFactory({
    MasterEntity: Shift,
    MasterActions: ShiftActions,
    EntityFetchAPI: shiftApi,
    FIELDS: SHIFT_FIELDS,
    options: {
        ENTITY_NAME_ID,
        PARAM_ID: 'shiftId',
        ENTITY_SETTINGS_NAME: 'shiftSettings'
    },
    mapEntityStateToProps: ({ state, props }) => {
        const teams = teamsSelector(state, props);
        return {
            teams
        };
    }
});

export default SingleShiftEditContainer;
